import React from 'react';
import { ToolbarProps } from './types';
import { ArcStack } from '@src/core/ui';
import { FindMe, Layers, Weather } from './components';

const Toolbar: React.FC<ToolbarProps> = () => {
  return (
    <ArcStack top={5} right={5} zIndex={1100} position='absolute' sx={{ overflow: 'visible' }}>
      <ArcStack spacing={1} direction='row' alignItems='start'>
        <Layers />
        <Weather />
        <FindMe />
      </ArcStack>
    </ArcStack>
  );
};

export default Toolbar;